export default __webpack_public_path__ + "static/media/home_oxford_owl.3d965a0b.mp3";